import { env } from "@/lib/env"

export function alertComingSoon(additionalText = "") {
  alert(`This feature is coming soon. ${additionalText}`)
}

export function isDevelopment() {
  return env("NEXT_PUBLIC_DEVELOPMENT") === "true"
}

// Print out the content of an object for debugging.
export function logObject(prompt: string, obj: unknown, _csrfToken: string) {
  if (obj) Object.entries(obj).forEach(([k, v]) => console.log(prompt, k, v))
  else console.log(prompt + "no data")
}

export function isColorLight(color: string): boolean {
  const hex = color.replace("#", "")
  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  return brightness > 155
}
